import {connect} from "react-redux";
import SearchOjects from "./SearchObjects";
import {
    getCountPagesSelector,
    getCurrentPageSelector, getObjectsPercentSelector,
    getObjectsSelector,
    getSearchStringSelector
} from "../../Objects/selectors";
import {clearSearch, searchObjects, setNewCurrentPage} from "../../Objects/actions";


let mapStateToProps = (state) => {
    return {
        objects: getObjectsSelector(state),
        objectsPercent: getObjectsPercentSelector(state),
        searchCountPages: getCountPagesSelector(state),
        searchString: getSearchStringSelector(state),
        searchCurrentPage: getCurrentPageSelector(state),
        verified: state.user.verified
    }
};



export default connect(mapStateToProps, {
    searchObjects,
    clearSearch,
    setNewCurrentPage
})(SearchOjects);




